import manager from 'app/module46/component-manager.js';

manager.register('listing', (component, elements, attributes, properties) => {
	
});
